/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MeterQueryParams } from '../models/MeterQueryParams';
import { request as __request } from '../core/request';

export class QueriesVService {

    /**
     * @param operatorId
     * @param districtId
     * @returns MeterQueryParams OK
     * @throws ApiError
     */
    public static async queriesVGetForReads(
        operatorId: string,
        districtId: string,
    ): Promise<MeterQueryParams> {
        const result = await __request({
            method: 'GET',
            path: `/api/v2/queries`,
            query: {
                'operatorId': operatorId,
                'districtId': districtId,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
        return result.body;
    }

}